export type TeamMember = {
  name: string;
  credentials?: string;
  role: string;
  specialties?: string[];
  bio: string[];
};

export const teamMembers: TeamMember[] = [
  {
    name: "Alexis Larson",
    credentials: "PT, DPT",
    role: "Doctor of Physical Therapy",
    specialties: ["Functional Dry Needling Certified"],
    bio: [
      "Alexis was drawn to physical therapy after navigating sports injuries in middle school. A high-school career-shadowing experience showed her how physical therapy can change what is possible in a person’s life, and she chose a profession that would let her know patients well and collaborate toward meaningful goals.",
      "Originally from Overland Park, Alexis earned her physical therapy degree from Rockhurst University. She enjoys working with a wide range of patients, with particular interest in active individuals, athletic backgrounds, and the milestones involved in post-operative rehabilitation.",
      "Outside the clinic, Alexis enjoys golf with her family, exploring Kansas City coffee shops and parks, attending concerts, and volunteering with Mission Adelante.",
    ],
  },
  {
    name: "Lauren Blando",
    credentials: "PT, DPT",
    role: "Doctor of Physical Therapy",
    specialties: ["Run DNA Certified", "Pelvic Floor Certified – Level 1"],
    bio: [
      "Lauren’s interest in athletics and the human body led her to physical therapy—a field that combines continual learning, varied clinical challenges, creative problem-solving, and meaningful patient relationships.",
      "A native of Leawood, Lauren earned her undergraduate degree from the University of Kansas and her Doctor of Physical Therapy degree from Rockhurst University. She enjoys caring for people of all ages and backgrounds and has particular interest in youth populations, knee injuries, and runners working to improve performance.",
      "Lauren stays active through running, yoga, weightlifting, basketball, and pickleball. She is also learning golf and enjoys cheering for the Kansas City Chiefs.",
    ],
  },
  {
    name: "Kacie Beebe",
    credentials: "PT, DPT",
    role: "Doctor of Physical Therapy",
    specialties: ["Functional Dry Needling Certified"],
    bio: [
      "Kacie’s path to physical therapy began with a shoulder injury that threatened her swimming career. A dedicated physical therapist helped her return to the pool and compete successfully at the state level. That experience inspired her to help other people pursue activities that matter to them.",
      "Kacie is from Olathe and completed physical therapy school at the University of Kansas Medical Center. She enjoys working across injury types and collaborating with people who are motivated to pursue their potential, wherever they are starting.",
      "Away from work, Kacie enjoys running, paddleboarding, triathlon training, and pickleball.",
    ],
  },
  {
    name: "Jennifer Caswell",
    credentials: "PT, DPT",
    role: "Chief Operating Officer and Doctor of Physical Therapy",
    specialties: ["Functional Dry Needling Certified", "Pilates Instructor"],
    bio: [
      "Originally from Oklahoma, Jennifer moved to Kansas City to earn her master’s degree in physical therapy at the University of Kansas Medical Center. She earned her Doctor of Physical Therapy degree in 2016 and has worked across diverse healthcare settings.",
      "Jennifer has served as a co-owner of CORE Strategies Physical Therapy since 2007. She devotes significant time to mentoring physical therapy students and staff and advocates for initiatives that improve access to physical therapy services.",
      "Outside the clinic, Jennifer enjoys outdoor activities with her husband and dogs.",
    ],
  },
  {
    name: "Michelle Ahern",
    role: "Front Office Clinical Coordinator",
    bio: [
      "Michelle joined CORE after more than 35 years of working with patients in neurology. She chose a private-practice setting because it allows a different level of connection, and she values building relationships while helping people find the care they need.",
      "Michelle grew up in Grandview, Missouri, and earned her bachelor’s degree from UMKC. She lives in Lee’s Summit with her husband and enjoys traveling to see her two adult children and extended family. She also volunteers with the Lee’s Summit North Robotics Team and BSA Scout Troop 220.",
    ],
  },
  {
    name: "Beth Monger",
    role: "Billing Coordinator",
    bio: [
      "Beth brings more than 15 years of medical-billing experience and a careful eye for insurance claims and financial documentation. She works to make billing processes accurate, efficient, and easier for patients to navigate.",
      "Beth grew up in Lawrence and lives in North Kansas City. She has six adult children and five grandchildren. An accomplished sewer, she enjoys turning simple materials into purses, handbags, keychains, coin purses, and other creative designs.",
    ],
  },
];

export const coreValues = [
  {
    title: "Be a hero",
    body: "Care is an active partnership. Our team works to help each person understand the path ahead and become a confident participant in their own movement health.",
  },
  {
    title: "Blaze a trail",
    body: "When familiar strategies have not created the change you want, careful evaluation and a different way of thinking can reveal a more useful direction.",
  },
  {
    title: "Choose your destination",
    body: "Movement health is not only about today’s symptom. We help people consider where they want their strength, confidence, and activity to be in the years ahead.",
  },
];

export const carePrinciples = [
  ["Collaborative approach", "Our team collaborates on challenging cases and values the perspective each person brings to the plan."],
  ["Movement is medicine", "We analyze how you move and use active strategies to build more effective options."],
  ["Innovative expertise", "Ongoing learning, evidence-informed tools, and thoughtful clinical reasoning guide our work."],
  ["Continuum of care", "Physical therapy, performance, Pilates, and fitness services share a consistent movement philosophy."],
  ["Comprehensive care", "We consider history, current needs, daily demands, and future goals—not a symptom in isolation."],
  ["Education is power", "Understanding your body and the purpose behind a plan helps the work last beyond the clinic."],
] as const;
